import axios from 'axios';
import { updateRedux } from './commonReducer';
import { API_BASE_INCIDENT_URL, API_BASE_URL } from "../constants/configuration";
import { Toast } from 'bootstrap';
import { toast } from 'react-toastify';
import apiClient from './apiClient';

export const getBanner = (callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/get-banner`).then((res) => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "banner_lists", value: res.data.banner }))
      dispatch(updateRedux({ key: "banner_path", value: res.data.path }))
      callback && callback(res.data.banner)
    } else {
      Toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err.response, "")
  })
}

export const getBannerType = (callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/get-banner-type`).then((res) => {
    if (res.data.status) {
      callback && callback(res.data.data)
    } else {
      Toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err.response, "")
  })
}

export const getVisionMission = (callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getVisionMission`).then((res) => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "visionMision_lists", value: res.data.visionMission }))
      callback && callback(res.data.visionMission)
    } else {
      Toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err.response, "6")
  })
}

export const getHome = (callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getHome`).then((res) => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "getHome_lists", value: res.data.home }))
      dispatch(updateRedux({ key: "home_path", value: res.data.path }))
      callback && callback(res.data.home)
    } else {
      Toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err, "6")
  })
}

export const getRolesAssign = (callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getRolesAssign`).then((res) => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "rolesAssign_lists", value: res.data.rolesAssign }))
      dispatch(updateRedux({ key: "rolesAssign_path", value: res.data.path }))
      callback && callback(res.data.rolesAssign)
    } else {
      Toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err.response)
  })
}

export const getAbout = () => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getAbout`).then((res) => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "About_details", value: res.data.about }))
      dispatch(updateRedux({ key: "about_path", value: res.data.path }))
    } else {
      Toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err.response, "6")
  })
}


export const getAboutValues = () => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getAboutValues`).then((res) => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "AboutValues_details", value: res.data.aboutValues }))
    } else {
      Toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err.response, "6")
  })
}


export const getContactInfo = () => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getContactInfo`).then((res) => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "contactInfo_details", value: res.data.contactInfo }))
      dispatch(updateRedux({ key: "contactInfo_path", value: res.data.path }))
    } else {
      Toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err.response, "6")
  })
}


export const submitContactMessages = (formData, callback) => () => {
  apiClient.post(`${API_BASE_URL}web/submitContactMessages`, formData).then(res => {
    if (res.data.status == true) {
      if (callback) {
        callback(res.data.status)
      }
    } else {
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
      if (callback) {
        callback(res.data.status)
      }
    }
  }).catch((err) => {
    console.log(err)
  })
}

export const getJurisdictionAuthorities = () => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getJurisdictionAuthorities`).then((res) => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "jurisdictionAuthorities_details", value: res.data.jurisdictionAuthorities }))
      dispatch(updateRedux({ key: "jurisdictionAuthorities_path", value: res.data.path }))
    } else {
      Toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err.response, "6")
  })
}

export const getOtp = (data, callback) => (dispatch) => {
  axios.post(`${API_BASE_INCIDENT_URL}web/getOtp`, data, {
    headers: {
      'language': localStorage.getItem('lang')
    },
  }).then(res => {
    console.log(res, 'response')
    if (res.data.status) {
      dispatch(updateRedux({ key: "otp_id", value: res.data.otp_id }))
      dispatch(updateRedux({ key: "expireTime", value: res.data.expireTime }))
      dispatch(updateRedux({ key: "incident_details", value: res.data.incident_details }))
      dispatch(updateRedux({ key: "showOtpSection", value: true }))
      dispatch(updateRedux({ key: "showTimer", value: true }))
      dispatch(updateRedux({ key: "timer_active", value: true }))
      dispatch(updateRedux({ key: "otp_loader", value: false }))
      dispatch(updateRedux({ key: "hide_send_otp", value: true }))
      dispatch(updateRedux({ key: "continue_timer", value: false }))
      if (callback) {
        callback(res.data)
      }
    } else {
      dispatch(updateRedux({ key: "otp_loader", value: false }))
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
      callback(res.data)
    }
  }).catch((err) => {
    // console.log(err)
    dispatch(updateRedux({ key: "otp_loader", value: false }))
    toast.error(err.response?.data.message, {
      position: "bottom-center",
      autoClose: 3000
    })
    callback(err.response?.data)
  })
}

export const resendOtp = (data, callback) => (dispatch) => {
  axios.post(`${API_BASE_INCIDENT_URL}web/resendOtp`, data, {
    headers: {
      'language': localStorage.getItem('lang')
    },
  }).then(res => {
    console.log(res, 'response')
    if (res.data.status) {
      dispatch(updateRedux({ key: "otp_id", value: res.data.otp_id }))
      dispatch(updateRedux({ key: "expireTime", value: res.data.expireTime }))
      dispatch(updateRedux({ key: "incident_details", value: res.data.incident_details }))
      dispatch(updateRedux({ key: "showOtpSection", value: true }))
      dispatch(updateRedux({ key: "showTimer", value: true }))
      dispatch(updateRedux({ key: "continue_timer", value: false }))
      dispatch(updateRedux({ key: "timer_active", value: true }))
      if (callback) {
        callback(res.data)
      }
    } else {
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    // console.log(err)
    toast.error(err.response?.data.message, {
      position: "bottom-center",
      autoClose: 3000
    })
  })
}

export const verifyOtp = (data, callback) => (dispatch) => {
  axios.post(`${API_BASE_INCIDENT_URL}web/verifyOtp`, data, {
    headers: {
      'language': localStorage.getItem('lang')
    },
  }).then(res => {
    // console.log(res, 'response',res.data.status)
    if (res.data.status) {
      dispatch(updateRedux({ key: "verify_status", value: res.data.incident_otp_verified === 1 ? true : false }))
      dispatch(updateRedux({ key: "incident_details", value: res.data.incident_details }))
      dispatch(updateRedux({ key: "showOtpSection", value: res.data.incident_otp_verified === 1 ? false : true }))
      callback && callback()
    } else {
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
      dispatch(updateRedux({ key: "verify_status", value: false  }))
    }
  }).catch((err) => {
    toast.error(err.response?.data.message, {
      position: "bottom-center",
      autoClose: 3000
    })
    dispatch(updateRedux({ key: "verify_status", value: false  }))
  })
}

export const getIncidentType = () => (dispatch) => {
  axios.get(`${API_BASE_INCIDENT_URL}web/getIncidentType`, {
    headers: {
      'language': localStorage.getItem('lang')
    },
  }).then(res => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "incident_type_details", value: res.data.incident_type_details }))
    } else {
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err)
  })
}

export const insertIncident = (formData, callback) => (dispatch) => {
  axios.post(`${API_BASE_INCIDENT_URL}web/insertIncident`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'language': localStorage.getItem('lang')
    },
  }).then(res => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "created_incident_number", value: res.data.incident_number }))
      toast.success(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
      if (callback) {
        callback()
      }
    } else {
      dispatch(updateRedux({ key: "submitLoader", value: false }));
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err)
  })
}

export const getIncidentContentDetails = (callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getIncidentContentDetails`, {
    headers: { 'language': localStorage.getItem('lang') },
  }).then(res => {
    if (res.data.status) {
      dispatch(updateRedux({ key: "incidentContent", value: res.data.incidentContent }))
    } else {
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err)
  })
}

export const getIncidentDetails = (id, callback) => {
  axios.get(`${API_BASE_INCIDENT_URL}web/getIncidentDetails/${id}`, {
    headers: { 'language': localStorage.getItem('lang') },
  }).then(res => {
    if (res.data.status) {
      callback(res.data)
    } else {
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err)
  })
}

export const updateIncident = (data, callback) => {
  axios.post(`${API_BASE_INCIDENT_URL}web/updateIncident`, data, {
    headers: {
      'language': localStorage.getItem('lang'),
      'Content-Type': 'multipart/form-data'
    },
  }).then(res => {
    if (res.data.status) {
      callback && callback(true, res.data)
    } else {
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
      callback && callback(false, res.data)
    }
  }).catch((err) => {
    console.log(err)
  })
}

export const getReturnedIncidentDetails = (data, callback) => {
  axios.post(`${API_BASE_INCIDENT_URL}web/getReturnedIncidentDetails`, data, {
    headers: { 'language': localStorage.getItem('lang') },
  }).then(res => {
    // if (res.data.status) {
    callback && callback(res.data)
    // } else {
    //   toast.error(res.data.message, {
    //     position: "bottom-center",
    //     autoClose: 3000
    //   })
    // }
  }).catch((err) => {
    console.log(err)
  })
}

export const ToggleStatus = (callback) => () => {
  apiClient.get(`${API_BASE_URL}admin/check-report-button`).then(res => {
    if (res.data.status) {
      callback && callback(res.data.data.status)
    }
  }).catch((err) => {
    console.log(err)
  })
}

export const getNews = ({ page, limit }, callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getNews${page !== undefined ? ('?page=' + page) : ''}${limit ? ('&limit=' + limit) : ''}`).then(res => {
    if (res.data.status) {
      callback && callback(res.data)
    } else {
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err)
  })
}

export const getNewsDetail = (id, callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getNewsDetails/${id}`).then(res => {
    if (res.data.status) {
      callback && callback(res.data)
    } else {
      callback && callback(res.data)
      // toast.error(res.data.message, {
      //   position: "bottom-center",
      //   autoClose: 3000
      // })
    }
  }).catch((err) => {
    console.log(err)
  })
}


export const getTagline = (callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/getTagline`).then(res => {
    if (res.data.status) {
      callback && callback(res.data.tagline)
    } else {
      toast.error(res.data.message, {
        position: "bottom-center",
        autoClose: 3000
      })
    }
  }).catch((err) => {
    console.log(err)
  })
}


export const getPrivacy = ( callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/privacy-policy`).then(res => {
    if (res.data.status) {
      callback && callback(res)
    } else {
      callback && callback(res)
    }
  }).catch((err) => {
    console.log(err)
  })
}

export const getTerms = ( callback) => (dispatch) => {
  apiClient.get(`${API_BASE_URL}web/terms-condition`).then(res => {
    if (res.data.status) {
      callback && callback(res)
    } else {
      callback && callback(res.data)
    }
  }).catch((err) => {
    console.log(err)
  })
}
